import { htBorderCodeForCell, htPdfLineWidthFromCode } from './htBorders';

export const HT_PDF_OUTER_LINE = 0.15;

export function htPdfRowHasTop(excelRow) {
  for (let c = 3; c <= 5; c += 1) {
    if (htBorderCodeForCell(excelRow, c).includes('t')) return true;
  }
  return false;
}

export function htPdfRowHasBottom(excelRow) {
  for (let c = 3; c <= 5; c += 1) {
    if (htBorderCodeForCell(excelRow, c).includes('b')) return true;
  }
  return false;
}

export function htPdfStrokeHLine(doc, x1, x2, y) {
  doc.setLineWidth(HT_PDF_OUTER_LINE);
  doc.line(x1, y, x2, y);
}

export function htPdfStrokeOuterVerticals(doc, xs, y, h) {
  doc.setLineWidth(HT_PDF_OUTER_LINE);
  doc.line(xs[0], y, xs[0], y + h);
  doc.line(xs[5], y, xs[5], y + h);
}

/** Marco fila a ancho B–F; divisiones internas opcionales (ej. cantidad en xs[3]). */
export function htPdfDrawFullWidthRowFrame(doc, xs, y, h, excelRow, innerSplits = []) {
  const x0 = xs[0];
  const xEnd = xs[5];
  htPdfStrokeOuterVerticals(doc, xs, y, h);
  doc.setLineWidth(HT_PDF_OUTER_LINE);
  innerSplits.forEach((x) => {
    doc.line(x, y, x, y + h);
  });
  if (htPdfRowHasTop(excelRow)) htPdfStrokeHLine(doc, x0, xEnd, y);
  if (htPdfRowHasBottom(excelRow)) htPdfStrokeHLine(doc, x0, xEnd, y + h);
}

export function htPdfDrawFullWidthBlockFrame(doc, xs, y, h, topRow, bottomRow, innerSplits = []) {
  const x0 = xs[0];
  const xEnd = xs[5];
  htPdfStrokeOuterVerticals(doc, xs, y, h);
  doc.setLineWidth(HT_PDF_OUTER_LINE);
  innerSplits.forEach((x) => {
    doc.line(x, y, x, y + h);
  });
  if (htPdfRowHasTop(topRow)) htPdfStrokeHLine(doc, x0, xEnd, y);
  if (htPdfRowHasBottom(bottomRow)) htPdfStrokeHLine(doc, x0, xEnd, y + h);
}

/** Bordes autoTable: sin “caja” C–E; solo divisiones internas + marco exterior en didDrawCell. */
export function htPdfAutotableBorderWidths(excelRow, excelCol) {
  if (excelCol === 2 || excelCol === 6) {
    return { top: 0, bottom: 0, left: 0, right: 0 };
  }
  let code = htBorderCodeForCell(excelRow, excelCol);
  if (excelCol === 3) code = code.replace(/l/g, '');
  if (excelCol === 5) code = code.replace(/r/g, '');
  code = code.replace(/t/g, '').replace(/b/g, '');
  return htPdfLineWidthFromCode(code);
}

export function htPdfAutotableDrawOuterFrame(data, marginLeft, tableWidth) {
  if (data.section !== 'body') return;
  const doc = data.doc;
  const { y, height } = data.cell;
  const excelRow = data.excelRow;
  const colCount = data.table.columns.length;
  const x0 = marginLeft;
  const xEnd = marginLeft + tableWidth;

  doc.setLineWidth(HT_PDF_OUTER_LINE);
  if (data.column.index === 0) doc.line(x0, y, x0, y + height);
  if (data.column.index === colCount - 1) doc.line(xEnd, y, xEnd, y + height);

  if (data.column.index === colCount - 1) {
    if (htPdfRowHasTop(excelRow)) htPdfStrokeHLine(doc, x0, xEnd, y);
    if (htPdfRowHasBottom(excelRow)) htPdfStrokeHLine(doc, x0, xEnd, y + height);
  }
}
